<template>
  <v-card class="rounded-lg mt-1" light height="50">
    <v-card class="position-absolute pos-left pos-top rounded-lg" color="#1da1f2" height="100%" width="20"></v-card>
    <v-card-title class="py-0 px-0">
      <v-avatar size="20" color="#1da1f2" class="mt-0 pt-0 ml-0" >
        <v-icon
          size="15"
          color="white"
        >
          mdi-twitter
        </v-icon>
      </v-avatar>
    </v-card-title>
    <v-card-text class="pb-0 mt-n6 px-8">
      <v-row>
        <v-col md="12" class="my-0 pt-3 pb-0">
          {{tweet.texto.length>max_length_text ? tweet.texto.slice(0,max_length_text)+'...' : tweet.texto}}
        </v-col>
        <v-col md="12" class="pt-1 pb-2">
          <v-row>
            <v-col md="2" class="pb-1 pt-0 px-3">
              <div>
                <small><b>Usuario:</b> {{tweet.data_productor}}</small>
              </div>
            </v-col>
            <v-divider
              vertical inset
            ></v-divider>
            <v-col md="2" class="pb-1 pt-0 px-3">
              <div>
                <small><b>Retweets:</b> {{tweet.retweets.toLocaleString('de')}}</small>
              </div>
            </v-col>
            <v-divider
              vertical inset
            ></v-divider>
            <v-col md="2" class="pb-1 pt-0 px-3">
              <div>
                <small><b>Favoritos:</b> {{tweet.favoritos}}</small>
              </div>
            </v-col>
            <v-divider
              vertical inset
            ></v-divider>
            <v-col md="2" class="pb-1 pt-0 px-3">
              <div>
                <small><b>Sentimiento:</b> {{tweet.sentimiento}}</small>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="py-0 mt-n5">
      <v-row>
        <v-col md="2" offset="10" class="py-0 text-right pt-0">
          <v-btn
            color="info"
            @click="mostrar_texto = true"
            large
            text
          >
            <strong>...</strong>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-dialog
      v-model="mostrar_texto"
      max-width="800"
    >
      <v-card light>
        <v-card-title>
          Tweet #{{tweet.data_id}}
        </v-card-title>
        <v-card-text>
          <json-view
            :data="tweet"
            rootKey="Detalles"
            :styles="{ arrowSize: '1px' }"
            class="customize"
          />

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="mostrar_texto = false"
          >
            cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import {JSONView} from "vue-json-component";

export default {
  props:{
    tweet:{
      type: Object,
      required:true
    }
  },
  data(){
    return{
      mostrar_texto:false,
      max_length_text:120
    }
  },
  components: { "json-view": JSONView },
}
</script>

<style lang="scss" scoped>
.customize {
  --vjc-arrow-size: 6px;
}
.customize.dark {
  --vjc-arrow-size: 6px;
}
</style>
<style lang="css" scoped>
.customize{
  font-weight: 200;
}
</style>
